import angular from 'angular';
import { sumBy } from 'lodash';

module.exports = angular.module('common.services.subtotal', [])
.value('subtotal', (adjustments) => sumBy(adjustments, 'amount_cents'))
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/subtotal.js
 **/